import { ofType, ActionsObservable } from 'redux-observable';
import { map, flatMap, switchMap } from 'rxjs/operators';
import { from } from 'rxjs';
import {format} from 'one-util-date';

import {
    setAction,
    reinitAction
} from 'one-state-btgpatient';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    RESET,
    SET_CERNER as patientSET
} from 'one-state-subject/src/types';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import { TransformResponse } from './transform';

import { Disposition } from 'one-model-local';

export const enum Types {
    FETCHPATIENTINFO = 'one-state-btgpatient/fetch-cerner',
}

export const enum Types { 
    STORE_DISPOSITION_CODE = "store-disposition-code",
}
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

/**
 * This Fuction will fetch the data of BTG PatientSearch
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */

export const fetchPatientSearchInfo_Cerner = (context: any) => (
    (action$: ActionsObservable<any>, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { serverone,
            log,
            agentId,
            teamName,
            settings:
            {
                cernerendpoints: { btgpatientsearch, apitoken },
                compatible 
            }
        } = context;
        const { contact_center_type } = compatible;
        return action$.pipe(
            ofType(Types.FETCHPATIENTINFO),
           
            switchMap((action: any) => {
                /**
                 * @param payloadRequest contains the selected Patient Data
                 */
                let payloadRequest: any = action.payload;
                const getRequest = (datares: any) => {
                    if (datares) {
                        let headers = new Headers();
                        // headers.set('Authorization', 'Basic ' + apitoken?.token);
                        
                        const response = serverone.get({
                            path: btgpatientsearch + "?family=" + datares?.name + "&birthdate=" + datares?.dob + "&given=" + datares?.given + "&identifier=" + datares?.identifier + "&PhoneNumber=" + datares.telecom,
                            headers: headers
                        })
                            .then((responsefound: any) => responsefound)
                            .catch((responseerror: any) => {
                                log.error(
                                    "ccw-gadget,patientsearch-cerner",
                                    "fetch-patientsearch-cerner", {
                                    responseerror
                                }
                                );
                                let errorbuild: ErrorObject={
                                    source:"PatientSearch",
                                    type:"error",
                                    status:responseerror?.status,
                                    erroritems:responseerror?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                        return from(response)
                    } else {
                        return from([]);
                    }
                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                return getRequest(payloadRequest).
                    pipe(
                        map((response: any) => TransformResponse(response, context))).
                    pipe(
                        flatMap(response => {
                            const actions: any = [
                                setAction(response)
                            ];
                            //If a patient is a NON-BTG patient.
                            if (response?.patientbtgdata?.resourceType === "Patient") {
                                let disp: Disposition = { value: "202" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = payloadRequest?.name;
                                disp.meta03 = payloadRequest?.given;
                                disp.meta04 =  payloadRequest?.telecom;
                                disp.meta05 = 'client';
                                disp.meta06=  "Non-BTG Patient";
                                actions.push(pushToDisposition(disp));
                            }
                            //If the  patient is a BTG Patient
                            else if(response?.patientbtgdata?.resourceType === "OperationOutcome") {
                                let disp: Disposition = { value: "203" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = payloadRequest?.name;
                                disp.meta03 = payloadRequest?.given;
                                disp.meta04 =  payloadRequest?.telecom;
                                disp.meta05 = 'client';
                                disp.meta06  = "BTG Patient";
                                actions.push(pushToDisposition(disp));
                            }
                            //If a PatientSearch API is throwing anerror.s
                            if (response.error) {
                                let disp: Disposition = { value: "1018" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = payloadRequest?.name;
                                disp.meta03 = payloadRequest?.given;
                                disp.meta04 =  payloadRequest?.telecom;
                                disp.meta05 = payloadRequest?.identifier;
                                disp.meta06 = 'client';
                                actions.push(pushToDisposition(disp));
                                actions.push(addAction(response.error));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);

/**
 * This Fuction will clear data of patientsearch Cerner
 * subsequent redux action
 * @param context contains the settings,logger etc..
 */
 export const clearPatientSearchCerner = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget,patientsearch-cerner",
            "Reset-PatientSearch-Cerner", {
        });
        return action$.pipe(
            ofType(patientSET, RESET),
            map(action => reinitAction())
        )
    }
);
